export default __webpack_public_path__ + "static/media/bernay16.6941e3e8.jpg";